import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import TeachHeader from './TeachHeader';
import './Tprofile'
import axios from '../Axiosinstance';
import { CLOUDINARY_UPLOAD_PRESET, baseURL,timestamp } from '../common';
import TextField from '@mui/material/TextField';
import bcrypt from 'bcryptjs';
import { ToastContainer, toast } from 'react-toastify';
import { Typography, CardContent, Button, CardHeader, Avatar, Grid, Box, Container, Card, Stack } from '@mui/material';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';




const Newbatch = () => {
  const [userData, setUserData] = useState({
    id: '',
    username: '',
    password: '',
    email: '',
    usertype: 0,
    sfid: 0,
    profile_Url: '',
    name: ''
  });
  const [uploadedFileUrl, setUploadedFileUrl] = useState('');
  const [modalOpen, setModalOpen] = useState(false); // State for modal visibility
  const [oldpassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();


  // Add these state variables:
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  useEffect(() => {
    // Retrieve the id from local storage
    const id = localStorage.getItem('userId');

    if (id) {
      // Make an API request to get user data
      axios.get(`/home/user/${id}`)
        .then((response) => {
          const userDataResponse = response.data;
          // Update the state with the response data
          setUserData(userDataResponse);
        })
        .catch((error) => {
          console.error('Error fetching user data:', error);
        });
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
      formData.append('public_id', 'LMS/profile/' + file.name +' - '+ timestamp);

      try {
        const response = await fetch(baseURL, {
          method: 'POST',
          body: formData,
        });
        const data = await response.json();
        if (data.secure_url !== '') {
          const url = data.secure_url;
          setUploadedFileUrl(url);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };



  // Function to handle saving changes
  const handleSaveChanges = () => {
    // Make a PUT request to update user details
    axios
      .put(`/home/user/${userData.userId}`, {
        ...userData,
        profile_Url: uploadedFileUrl || userData.profile_Url, // Use the uploadedFileUrl if available, else retain the existing URL
      })
      .then((response) => {
        // Handle success, e.g., show a success message
        console.log('User details updated:', response.data);
        toast.success('User details updated successfully!', {
          position: 'bottom-right',
          autoClose: 3000, // Close the toast after 3 seconds
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,

        });
        // window.location.reload();
      })
      .catch((error) => {
        // Handle errors, e.g., show an error message
        console.error('Error updating user details:', error);
        toast.error('Error updating user details. Please try again.', {
          position: 'bottom-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
      });
  };

  const handleSave = () => {
    if (newPassword !== confirmPassword) {
      setErrorMessage("New password and Confirm password do not match.");
      return;
    }
    setErrorMessage("");
    handleChangePassword(oldpassword, newPassword); // pass values here
  };

  const handleChangePassword = async (oldpassword, newPassword) => {
    // Check if the old password matches the stored hashed password
    const isMatch = await bcrypt.compare(oldpassword, userData.password);

    if (isMatch) {
      // Hash the new password
      const salt = await bcrypt.genSalt(10);
      const hashedNewPassword = await bcrypt.hash(newPassword, salt);

      // Create an updated user data object
      const updatedUserData = {
        ...userData, // spread existing user data
        password: hashedNewPassword, // replace the old password with the new hashed password
      };

      console.log('Updated user data:', updatedUserData); // Log the updated user data

      // Make a PUT request to update user details
      axios.put(`/home/user/${userData.userId}`, updatedUserData)
        .then(response => {
          toast.success('User details updated successfully!', {
            position: 'bottom-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          });

          // Close the modal after successful update
          setModalOpen(false);

          // Clear the modal input fields
          setOldPassword('');
          setNewPassword('');
          setErrorMessage('');
          setConfirmPassword('');
          // window.location.reload();
        })
        .catch(error => {
          console.error('Error updating user details:', error);
          toast.error('Error updating user details. Please try again.', {
            position: 'bottom-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          });
        });
    } else {
      setErrorMessage('Old password is incorrect.');
    }
  };

  return (
    <Container maxWidth="md" >
      <Box my={4} style={{ width: '100%' }
      }>
        <Typography variant="h4" gutterBottom align="left" style={{ marginBottom: '20px' }}>
          <Link to=" " style={{ textDecoration: 'none', color: '#3f51b5', fontWeight: 'bolder' }}>Teacher Profile </Link>
        </Typography>
        < Card elevation={3} style={{ padding: '20px' }}>
          <CardHeader
            title="Account Details"
            avatar={< Avatar src={userData.profile_Url} alt="Profile" />}
            titleTypographyProps={{ variant: 'h6', align: 'left' }}
            style={{ textAlign: 'left' }}
          />
          < CardContent >
            <form>
              <Grid container spacing={3} >
                <Grid item xs={12} sm={6} >
                  <TextField
                    fullWidth
                    label="Username"
                    id="inputUsername"
                    name="name"
                    type="text"
                    value={userData.name}
                    onChange={handleInputChange}
                    variant="outlined"
                  />
                </Grid>
                < Grid item xs={12} sm={6} >
                  <TextField
                    className="form-control"
                    fullWidth
                    label="Email"
                    id="inputEmail"
                    name="email"
                    type="email"

                    value={userData.email}
                    onChange={handleInputChange}
                    variant="outlined"
                  />
                </Grid>


                < Grid item xs={12} >
                  <label htmlFor="fileupload" style={{ fontWeight: 'bold' }}> Upload Profile Image </label>
                  <input type="file" id="fileupload" onChange={handleFileUpload} style={{ marginTop: '10px', display: 'block' }} /><br />
                  {userData.profile_Url && (
                    <Box mt={2} textAlign="center" >
                      <img src={userData.profile_Url} alt="Profile" style={{ width: '150px', height: '150px' }} />
                    </Box>
                  )}
                </Grid>
              </Grid>
              <Box mt={3} textAlign="center">
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={2}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setModalOpen(true)}
                  >
                    Change Password
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handleSaveChanges}
                  >
                    Save Changes
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                </Stack>
              </Box>
            </form>
          </CardContent>
        </Card>



        {/* Password Change Modal */}
        <Modal centered show={modalOpen} onHide={() => setModalOpen(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Change Password</Modal.Title>
          </Modal.Header>


          <Modal.Body>
            <TextField
              label="Old Password"
              type={showOldPassword ? 'text' : 'password'}
              fullWidth
              value={oldpassword}
              onChange={(e) => setOldPassword(e.target.value)}
              margin="normal"
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowOldPassword(!showOldPassword)} edge="end">
                      {showOldPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            {errorMessage && <Typography color="error">{errorMessage}</Typography>}

            <TextField
              label="New Password"
              type={showNewPassword ? 'text' : 'password'}
              fullWidth
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              margin="normal"
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowNewPassword(!showNewPassword)} edge="end">
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

            <TextField
              label="Confirm Password"
              type={showConfirmPassword ? 'text' : 'password'}
              fullWidth
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              margin="normal"
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Modal.Body>

          <Modal.Footer style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            <Button variant="contained" color="primary" onClick={handleSave}>
              Save
            </Button>
            <Button variant="contained" color="secondary" onClick={() => setModalOpen(false)}>
              Close
            </Button>

          </Modal.Footer>
        </Modal>
      </Box>
      < ToastContainer />
    </Container>

  );
};


const NewbatchPage = () => {
  return (
    <div>
      <TeachHeader />
      <Newbatch />
    </div>
  );
};


export default NewbatchPage;




